import { PropertyBusinessType } from './Properties';

export interface WidgetSettings {
  hideMinimumStay: boolean;
  showPricingDetails: boolean;
  hidePriceWhenDateNotEntered: boolean;
  requirePassportId: boolean;
  requireGuestPhoneNumber: boolean;
}

export enum SocialPlatform {
  FACEBOOK = 'FACEBOOK',
  INSTAGRAM = 'INSTAGRAM',
  TWITTER = 'TWITTER',
  LINKEDIN = 'LINKEDIN',
  YOUTUBE = 'YOUTUBE',
  PINTEREST = 'PINTEREST',
  TIKTOK = 'TIKTOK',
  WHATSAPP = 'WHATSAPP',
  SNAPCHAT = 'SNAPCHAT',
  YELP = 'YELP',
  REDDIT = 'REDDIT',
  VIMEO = 'VIMEO',
  FOURSQUARE = 'FOURSQUARE',
  TRIPADVISOR = 'TRIPADVISOR',
}

export interface SocialLink {
  type: SocialPlatform;
  url: string;
}

export interface Tracking {
  googleAnalyticsId: string | null;
  googleTagManagerId: string | null;
  metaPixelId: string | null;
}

export interface NavigationItem {
  uid: string;
  name: string;
  url: string;
  openLinkInNewTab: boolean;
  title: string | null;
}

export type NavigationItemPayload = Omit<NavigationItem, 'uid' | 'title'> &
  Partial<Pick<NavigationItem, 'uid' | 'title'>>;

export interface DbsSettings {
  agencyUid: string;
  heroUrl: string | null;
  headline: string | null;
  subHeadline: string | null;
  welcomeTitle: string | null;
  welcomeContent: string | null;
  headlineColor: string | null;
  primaryColor: string | null;
  secondaryColor: string | null;
  featuredPropertyUids: string[];
  navigation: NavigationItem[];
  socialLinks: SocialLink[];
  tracking: Tracking;
  whiteLabelEnabled: boolean;
  widgetCtaTitle: string | null;
  widgetSettings: WidgetSettings;
}

export interface SelectableFeaturedProperty {
  uid: string;
  name: string;
  businessType: PropertyBusinessType;
  hotelUid: string | null;
  hotelName: string | null;
}

export interface GetDbsSettingsResponseTO {
  dbsSettings: DbsSettings;
}

/**
 * The endpoint merges the payload onto the stored settings, so anything left out keeps its
 * current value and anything sent as null is cleared.
 */
export type UpdateDbsSettingsPayload = Partial<
  Omit<
    DbsSettings,
    'agencyUid' | 'heroUrl' | 'navigation' | 'widgetSettings' | 'tracking'
  >
> & {
  navigation?: NavigationItemPayload[];
  widgetSettings?: Partial<WidgetSettings>;
  tracking?: Partial<Tracking>;
};
